
import {toRefs, reactive, defineComponent, PropType, computed, onMounted} from 'vue'
import DealDTO from "@/models/DealDTO";
import {paymentMethodsHelper} from "@/service/PaymentMethodsHelper"
import {numberFormatter} from "@/service/NumberFormatter"
import InvoiceStateDTO from "@/models/InvoiceStateDTO";
import PayByAppButton from "@/components/PayButtons/PayByAppButton.vue";
import SberpayButton from "@/components/PayButtons/SberpayButton.vue";
import TPayButton from "@/components/PayButtons/TPayButton.vue";
import {FlowType} from "@/enum/FlowType";
import { event } from 'vue-gtag'
import copyTextToClipboard from "@/service/CopyHelper";
import AlfapayButton from "@/components/PayButtons/AlfapayButton.vue";
import VTBPayButton from "@/components/PayButtons/VTBPayButton.vue";
import GazprombankButton from "@/components/PayButtons/GazprombankButton.vue";
import PSBPayButton from "@/components/PayButtons/PSBPayButton.vue";
import OzonPayButton from "@/components/PayButtons/OzonPayButton.vue";
import WBPayButton from "@/components/PayButtons/WBPayButton.vue";
import SovkomPayButton from "@/components/PayButtons/SovkomPayButton.vue";
import {requisitesUrl} from "@/service/helper";
import {bankPayFlowsIn} from "@/service/bankPayFlows";

const apiUrl = window.API_URL;

export default defineComponent({
  components: {GazprombankButton, PSBPayButton, OzonPayButton, VTBPayButton, AlfapayButton, TPayButton, SberpayButton, PayByAppButton, WBPayButton, SovkomPayButton},
  props: {
    currentDeal: {
      type: Object as PropType<DealDTO>,
      default: false
    },
    invoice: {
      type: Object as PropType<InvoiceStateDTO>,
      default: false
    }
  },
  setup(props) {

    const state = reactive({
      copyHintTimeout: null as number|null,
      copyValue: '' as string,
      appList: false,
      deeplinkClicked: false as boolean
    });

    const isAppListCanShowed = computed(() => {
      if (props.invoice.flow !== FlowType.DEFAULT) {
        return false;
      }
      return bankPayFlowsIn(props.invoice.flowData).length > 0
    })

    const flowInstructions = (flowKey: FlowType): string[] => {
      const block = props.invoice.flowData?.[flowKey] as {instructions?: unknown} | undefined
      const instructions = block?.instructions
      if (!Array.isArray(instructions)) {
        return []
      }
      return instructions.filter((line): line is string => typeof line === 'string')
    }

    const requisitesLink = computed(() => requisitesUrl(props.currentDeal))

    const showAppList = () => {
      state.appList = true
      event(`payByApps`, {visible: state.appList})
    }

    const hideAppList = (el:any) => {
      if (el && el.target && el.target.id !== 'app-list') {
        return;
      }

      state.appList = false
    }

    const copy = (obj: any, value: string) => {
      state.copyValue = value
      copyTextToClipboard(obj, value);
      if (state.copyHintTimeout) {
        clearTimeout(state.copyHintTimeout)
      }
      state.copyHintTimeout = setTimeout(() => {
        state.copyHintTimeout = null;
      }, 1000);
    }

    const formatCC = (value: string): string => {
      return value
    }

    const openDeeplink = (deeplinks: any) => {
      event('deeplinkClicked', {})

      state.deeplinkClicked = true;
      _openDeeplink(0, deeplinks);
    }

    const payBySber = () => {
      const requisite = props.currentDeal.requisites.requisites;
      const digits = requisite.replace(/\D/g, '');
      const shouldTrim = props.currentDeal.paymentOption === 'MOBILE_TOP_UP' && (digits.startsWith('996') || digits.startsWith('992'));
      copyTextToClipboard(null, shouldTrim ? digits.slice(3) : requisite);
      openDeeplink(props.invoice.flowData[FlowType.SBERPAY].deeplinks);
    }

    const payByOzon = () => {
      const digits = props.currentDeal.requisites.requisites.replace(/\D/g, '');
      copyTextToClipboard(null, digits);
      openDeeplink(props.invoice.flowData[FlowType.OZONPAY].deeplinks);
    }

    const _openDeeplink = (index: number, deeplinks: any) => {
      const deeplink = deeplinks[index]
      event('deeplink', {link: deeplink})
      window.open(deeplink, "_self")
      index++

      if (!deeplinks[index]) {
        return;
      }


      setTimeout(() => {
        _openDeeplink(index++, deeplinks);
      }, 1000);
    }

    const isDeeplinkClicked = () => {
      return state.deeplinkClicked
    }


    onMounted(async () => {
      document.addEventListener('visibilitychange', async function (event) {
        if (isDeeplinkClicked()) {
          document.location.reload()
        }
      });
    });

    return {
      ...toRefs(state),
      paymentMethodsHelper,
      numberFormatter,
      formatCC,
      copy,
      apiUrl,
      requisitesLink,
      showAppList,
      hideAppList,
      isAppListCanShowed,
      FlowType,
      openDeeplink,
      payBySber,
      flowInstructions,
      payByOzon,
    }
  }
})
